<template>
<div class="mainwrap">

    <div class="tune-widget-mainbar">
        <div class="tune-widget-mainbar-l">
            <img :src="img1" class="header-image" alt="start image">
        </div>
        <div class="tune-widget-mainbar-m">{{ $t("request_info") }}</div>
        <div class="tune-widget-mainbar-r"> &nbsp;</div>
    </div>


            <div class="main-header" >{{ $t("request_info") }}</div>
    <div v-if="!sent" class="shop-results">
    <div style="float:left;padding:1%;">



    
            <!-- // Customer name -->
            <div class="generic-form-row">
                <div class="generic-form-label">{{ $t("name") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
                <div class="generic-form-value"><input type="text" class="default-input" id="customer_name" name="customer_name" placeholder="" :value="curOrder.name"></div>
            </div>

            <!-- // Shipping zip + city -->
            <div class="generic-form-row">
                <div class="generic-form-label">{{ $t("city") }} / {{ $t("country") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
                <div class="generic-form-value">
                    <input type="text" class="default-input"  style="width:50%;" id="shipping_city" name="shipping_city" placeholder="" :value="curOrder.shipping_city">
                    <div class="generic-form-value" style="float:right;line-height:2vh;width:45%;"><span v-html='renderDDLB("shipping_country", countries, curOrder.shipping_country, $t("country"))'></span></div>
                    </div>
            </div>

                   <!-- Phone -->
            <div class="generic-form-row">
                <div class="generic-form-label">{{ $t("phone") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
                <div class="generic-form-value"><input type="text" class="default-input" id="customer_phone" name="customer_phone" placeholder="" ></div>
            </div>

            <!-- Email address -->
            <div class="generic-form-row">
                <div class="generic-form-label">{{ $t("email") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
                <div class="generic-form-value"><input type="text" class="default-input" id="customer_email" name="customer_email" placeholder="" :value="curOrder.email"></div>
            </div>

     

            <!-- // License plate or VIN -->
            <div class="generic-form-row">
                <div class="generic-form-label">{{ $t("plate_or_vin") }}</div>
                <div class="generic-form-value"><input type="text" class="default-input" id="customer_platevin" name="customer_platevin" placeholder="" :value="curOrder.license_plate"></div>
            </div>
            <!-- // Make + MOdel + Year + Engine -->
            <div class="generic-form-row">
                <div class="generic-form-label">{{ $t("make_model_year_engine") }}</div>
                <div class="generic-form-value"><input type="text" class="default-input" placeholder="" :value="removeBR(this.fullSelectionDesc())" disabled></div>
            </div>

            <!-- // Additional info / notes -->
            <div class="generic-form-row">
                <div class="generic-form-label">{{ $t("your_question") }} <span style="color:#DF2F00;vertical-align:top; ">*</span></div>
                <div class="generic-form-"><textarea class="default-input-textarea" style="height:140px;" id="customer_question" name="customer_question" placeholder=""></textarea></div>
            </div>                
            <div class="generic-form-row">&nbsp;</div>
   

            <div class="generic-form-row" >
                <div class="two-button-left">
                  <div class="tune-action-button" @click="this.$router.push('/')">{{ $t("go_back") }}</div>
                </div>
                <div class="two-button-right">
                   <div class="tune-action-button" @click="sendInfoRequest()">{{ $t("request_info") }}</div>
                </div>
            </div>


            <!-- <div class="checkout-row">{{ this.$store.state.curSelectedMake }}</div> -->


        </div> 
        </div> 



        <div v-if="sent" class="shop-results">
      
            <div class="checkout-row">&nbsp;</div>
            <div class="checkout-row" style="text-align:center;">
                <div class="" style="float:left;width:100%;">
                    <div class="text-block-margin">
                        {{ $t("inforequest_sent") }}
                    </div>
                    <div class="checkout-row">
                        <div class="checkout-field-value" ><div class="tune-action-button" style="width:200px;display:inline-block;" @click="this.$router.push('/')">{{ $t("go_back") }}</div></div>
                    </div>
                </div>
            </div>

        </div>

  <transition name="modal">
    <modal v-if="showModal" @close="showModal = false">
      <!--
        you can use custom content here to overwrite
        default content
      -->
     <template v-slot:header>
            <span v-html="curModalHeader"></span>
        </template>
      <template v-slot:body>
        <span v-html="curModalBody" style="display:inline-block;width:380px;height:80px;"></span>
      </template>

        <template v-slot:footer>
            <button class="modal-default-button" @click="showModal = false; hideProductAction()">
                {{ $t("ok")}}
            </button>
        </template>
    </modal>
  </transition>


   
   

    </div>




</template>


<script>
import axios from 'axios'

export default {
    data() {
        var countries = {};
        var curLocale = this.$i18n.locale;
        window.curStrings = this.$i18n.messages[curLocale]; 
        var apiHost =  process.env.VUE_APP_RICA_API_HOST;
        var sent = false;
        var showModal = false;
        var curModalHeader = "";
        var curModalBody = "cur body";
        var curModalFooter = "cur footer"; 
        return {
            img1:require('./../assets/header-logo.png'), 
            emailIcon:require('./../assets/button-email.png'),
            phoneIcon:require('./../assets/button-contact.png'),
            locationIcon:require('./../assets/button-location.png'),           
            countries: countries,
            apiHost,
            sent,
            showModal:showModal,
            curModalHeader:curModalHeader,
            curModalBody:curModalBody,
            curModalFooter:curModalFooter
        }
    },
    computed: {
    shoppingCart: function () {
      return this.$store.state.shoppingCart;
    },
    curOrder: function () {
      return this.$store.state.curOrder;
    }},
    props:[ 'closePopup' ],
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
            if(window.parentIFrame) {
                window.parentIFrame.scrollTo(0,0);
            }
        },
        hideProductAction() {
            this.closePopup();
        },
         renderModal(msg) {
            this.showModal = true;
            this.curModalBody = msg;

        }, 
        fullSelectionDesc() {
             var fullDescription = "";
           console.log("this.$store.state.curMakes > " + this.$store.state.curMakes);
            // get make description
            for(var i=0 ; i < this.$store.state.curMakes.length ; i++) {
                console.log("this.$store.state.curMakes[i].MakeID > " + this.$store.state.curMakes[i].MakeID);
                if(this.$store.state.curSelectedMake == this.$store.state.curMakes[i].MakeID) {
                    fullDescription += this.$store.state.curMakes[i].Make + " "; 
                }
            }

            // get model description
            for(var i=0 ; i < this.$store.state.curModels.length ; i++) {
                if(this.$store.state.curSelectedModel == this.$store.state.curModels[i].ModelID) {
                    fullDescription += this.$store.state.curModels[i].Model + " - ";
                }
            }

            // get variant description
            for(var i=0 ; i < this.$store.state.curVariants.length ; i++) {
                if(this.$store.state.curSelectedVariant == this.$store.state.curVariants[i].VehicleID) {
                    fullDescription += this.$store.state.curVariants[i].Description; 
                }
            }
            return  fullDescription;

        },
        sendInfoRequest() {
        // validate form

            var formValid = this.validateForm();
            console.log("formValid =" + formValid)


            if(formValid["status"] == "success") {

                var par = this;
                var postvars = new URLSearchParams();
                postvars.append('ep', 'inforequest');
                postvars.append('data', '[' + JSON.stringify(formValid["postdata"]) + ']');

                // post to gateway
                axios.post(this.apiHost, postvars)
                .then(function(response) {
                    console.log("Send mail response :" + JSON.stringify(response.data));
                    par.sent = true;
                    par.scrollToTop();
                    // this.renderModal(window.curStrings["inforequest_sent"]);
                    // par.hideProductAction();
                })
                .catch(function (error) {
                    console.log("Sending mail failed :" + error);
                    console.log(error);
                })

            } else {
                alert(formValid["msg"]);
            }
        },
        validateForm() {
            var result = Array();
            result["status"] = "success";
            var email = document.getElementById("customer_email").value;
            var name = document.getElementById("customer_name").value;
            var phone = document.getElementById("customer_phone").value;
            var platevin = document.getElementById("customer_platevin").value;            
            // var chassis_number = document.getElementById("customer_chassisno").value;
            // var license_plate = document.getElementById("customer_licenseplate").value;

            var city = document.getElementById("shipping_city").value;
            var country = document.getElementById("shipping_country").value;
            var question = document.getElementById("customer_question").value;
            // billing
            var missingFields = "Please fill in the fields: \n";
            if(name == "") {
                result["status"] = "failed";
                missingFields += "Please enter your name \n";
            }            
            if(email == "") {
                result["status"] = "failed";
                missingFields += "Please enter a valid email address \n";
            } 
            if(city == "") {
                result["status"] = "failed";
                missingFields += "Please enter your city \n";
            } 
            if(country == "") {
                result["status"] = "failed";
                missingFields += "Please enter your country \n";
            }                 
            if(phone == "") {
                result["status"] = "failed";
                missingFields += "Please enter your phone # \n";
            }
            if(question == "") {
                result["status"] = "failed";
                missingFields += "Your question \n";
            }
          
            var postData = {};
            postData["email"] = email; 
            postData["name"] = name; 
            postData["phone"] = phone; 
            // postData["license_plate"] = license_plate; 
            // postData["chassisno"] = chassis_number; 
            postData["city"] = city; 
            postData["country"] = country;
            postData["platevin"] = platevin;              
            postData["selectedMake"] = this.$store.state.curSelectedMake; 
            postData["selectedModel"] = this.$store.state.curSelectedModel; 
            postData["selectedVariant"] = this.$store.state.curSelectedVariant; 
            // var fullDescription = "";
            var fullDescription = this.fullSelectionDesc();
            postData["vehicleDetails"] = fullDescription; 
            postData["productDetails"] = this.$store.state.curSelectedProduct.Category; 
            postData["question"] = question; 
            postData["language"] = this.$i18n.locale; 
            postData["hostDomain"] = this.$store.state.hostDomain; 

             
            // console.log("postData" + JSON.stringify(postData));return false;
            result["msg"] = missingFields;
            result["postdata"] = postData;
            return result;
        }
    },
    mounted() {
    var par = this;
    // this.scrollTo(0,0);
    this.scrollToTop();

    console.log("mounted-> countries:" );
        var countriesURL = this.apiHost+"?ep=countries";
        axios.get(countriesURL )
        .then(function(response) {
            console.log("response: " + JSON.stringify(response.data));
            par.countries = response.data
        })
        .catch(function (error) {
            console.log(error);
        })
    }
}
</script>

<style>

</style>